<template>
    <button class="button filled accent-1 download" @click.prevent="exportToPDF">
        {{ buttonText }}
    </button>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
    props: {
        targetElId: {
            type: String
        },
        buttonText: {
            type:    String,
            default: "Download PDF"
        },
        fileName:   {
            type:    String,
            default: "coaching-exercise.pdf"
        }
    },

    data() {
        return {};
    },
    mounted() {
        // console.log('pdfGenerator component mounted')
        // console.log(this.targetElId)
    },
    methods: {
        exportToPDF() {
            html2pdf(document.getElementById(this.targetElId), {
                margin:      [.5, .5],
                autoPaging:  'text',
                filename:    this.fileName,
                html2canvas: {
                    allowTaint:      true,
                    letterRendering: true,
                    logging:         false,
                    scale:           1,
                },
                jsPDF:       {unit: 'in', format: 'A4', orientation: 'portrait'}
            });
        },
    }
}

</script>
